import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'a7-loading-logo',
    templateUrl: './loading-logo.component.html',
    styleUrls: ['./loading-logo.component.scss'],
    standalone: false
})
export class LoadingLogoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
